import { Injectable } from '@angular/core';
import { Course, CourseTemplate, Order, Region } from 'app/shared/models';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class GlobalFunctionsService {
  appInitialized = false;
  returnUrl: string;
  selectedCourseTemplate: CourseTemplate;
  selectedRegion: Region;
  selectedIssuer: string;

  private selectedCourse: Course;
  private order: Order;

  private updateSelectedCourseFunction = new Subject<Course>();
  private enableTabsFunction = new Subject<number>();
  private studentsFunction = new Subject<number>();
  private showBasketFunction = new Subject<boolean>();
  private showTabsFunction = new Subject<boolean>();

  showBasket(showBasket: boolean): void {
    this.showBasketFunction.next(showBasket);
  }

  showBasketChanged(): Observable<boolean> {
    return this.showBasketFunction.asObservable();
  }

  showTabs(showTabs: boolean): void {
    this.showTabsFunction.next(showTabs);
  }

  showTabsChanged(): Observable<boolean> {
    return this.showTabsFunction.asObservable();
  }

  updateSelectedCourse(selectedCourse: Course): void {
    this.selectedCourse = selectedCourse;
    this.updateSelectedCourseFunction.next(selectedCourse);
  }

  selectedCourseUpdated(): Observable<Course> {
    return this.updateSelectedCourseFunction.asObservable();
  }

  enableTabs(tabCount: number): void {
    this.enableTabsFunction.next(tabCount);
  }

  enabledTabsChanged(): Observable<number> {
    return this.enableTabsFunction.asObservable();
  }

  updateOrder(order: Order): void {
    this.order = order;
  }

  updateStudentCount(count: number): void {
    this.studentsFunction.next(count);
  }

  studentCountUpdated(): Observable<number> {
    return this.studentsFunction.asObservable();
  }

  getSelectedCourse(): Course {
    return this.selectedCourse;
  }

  getOrder(): Order {
    return this.order;
  }
}
